import React from 'react';

function ViewImagePage() {
    const imageName = window.location.pathname.split('/').pop(); 
    const serverBaseUrl = "/az-storage/img";

    return (
        <div className="image-container">
        <img 
            src={`${serverBaseUrl}/${imageName}`} 
            alt="Uploaded" 
            loading="lazy" 
            onError={(e) => {
            // Xử lý nếu ảnh bị lỗi hoặc không tồn tại
                 e.target.src = '/path-to-default-avatar.png'; 
            }}
        />
        </div>
    );
}

export default ViewImagePage;